'use strict';

angular.module('imagetrend.components')
    .directive('hlpFormGroups', [function () {
        return {
            restrict: 'AE',
            scope: {
                component: '=?',
                initializeAnswers: '&',
                parameters: '=?',
                resultSet: '=?',
                deficiencies: '=?',
                pdf: '=?',
                datapointAnswers: '=?',
                completed: '=?',
                saving: '=?',
                deficiencyScore: "=?",
                inspectionChecklist: "=?",
                defaultGroup: "=?"
            },
            controller: ['$scope', '$rootScope', '$filter', '$uibModal', '$window', 'Vehicles', function ($scope, $rootScope, $filter, $uibModal, $window, Vehicles) {
                var modalInstance = null;

                $scope.addGroup = function (component) {
                    component.groups.forEach(function (group) {
                        $scope.setEdit(group);
                    });

                    var defaultGroup = null;
                    if (component.default_group != null) {
                        defaultGroup = component.default_group;
                    }
                    else {
                        defaultGroup = component.groups[0];
                    }

                    var group = {};
                    group.id = guid();
                    group.edit = true;
                    group.added = true; 
                    if (component.data_set_code == "service_user_changes") {
                        group.component_allow_multiple_groups = component.allow_multiple_groups;
                        group.component_group_add = component.allow_group_addition;
                        group.component_group_remove = component.allow_group_removal;
                        group.component_group_update = component.allow_group_update;
                    }
                    group.sort_order = component.groups.length + 1;
                    group.component_id = component.id;
                    group.component_data_set_code = component.data_set_code;
                    group.questions = [];
                    defaultGroup.questions.forEach(function (defaultQuestion) {
                        var question = angular.copy(defaultQuestion);
                        var document_type_copy = null;
                        var document_name_copy = null;
                        if (typeof question.answer.document_type !== 'undefined') {
                            document_type_copy = question.answer.document_type;
                            document_name_copy = question.answer.document_name;
                        }
                        question.group_id = group.id;
                        question.answer = {};
                        question.answer.document_type = document_type_copy;
                        question.answer.document_name = document_name_copy;
                        question.answer.id = guid();
                        question.answer.value = question.default_value;
                        question.answer.show_value = null;
                        question.answer.note = null;
                        question.answer.phone_ext = null;
                        question.answer.document_id = null;
                        question.answer.result_set_id = null;
                        question.answer.fail = null;
                        question.answer.show_comments = null;
                        question.answer.group_id = group.id;
                        question.answer.question_id = question.id;
                        question.answer.encrypted = question.question_type.encrypted;
                        question.answer.data_point_id = question.data_point_id;
                        question.answer.data_point_code = question.data_point_code;
                        question.answer.required = question.required;
                        $scope.initializeSubComponentAnswers(question);

                        group.questions.push(question);
                    })
                    component.groups.push(group);
                    $scope.initializeAnswers();
                }

                $scope.initializeSubComponentAnswers = function (question) {
                    question.sub_components.forEach(function (component) {
                        var defaultGroup = null;
                        if (component.default_group != null) {
                            defaultGroup = component.default_group;
                        }
                        else {
                            defaultGroup = component.groups[0];
                        }

                        component.groups = [];
                        var group = {};
                        group.id = guid();
                        group.sort_order = 1;
                        group.component_id = component.id;
                        group.component_data_set_code = component.data_set_code;
                        group.questions = [];

                        defaultGroup.questions.forEach(function (defaultQuestion) {
                            var question = angular.copy(defaultQuestion);
                            var document_type_copy = null;
                            if (typeof question.answer.document_type !== 'undefined') { document_type_copy = question.answer.document_type; }
                            question.group_id = group.id;
                            question.answer = {};
                            question.answer.document_type = document_type_copy;
                            question.answer.id = guid();
                            question.answer.value = question.default_value;
                            question.answer.show_value = null;
                            question.answer.note = null;
                            question.answer.phone_ext = null;
                            question.answer.document_id = null;
                            question.answer.result_set_id = null;
                            question.answer.fail = null;
                            question.answer.show_comments = null;
                            question.answer.group_id = group.id;
                            question.answer.question_id = question.id;
                            question.answer.encrypted = question.question_type.encrypted;
                            question.answer.data_point_id = question.data_point_id;
                            question.answer.data_point_code = question.data_point_code;
                            question.answer.required = question.required;
                            $scope.initializeSubComponentAnswers(question);

                            group.questions.push(question);
                        })

                        component.groups.push(group);
                    })
                }

                $scope.getAnswer = function (question, group) {
                    if (!question) {
                        return undefined;
                    }
                    var value = question.answer.show_value == null ? question.answer.value : question.answer.show_value;

                    if (value != null && question.question_type.code == 'date') {
                        value = $filter('date')(new Date(value), 'MMMM d, y');
                    }
                    if (value != null && angular.isArray(value)) {
                        var stringVal = null;
                        value.forEach(function (val) {
                            if (typeof val != "undefined") {
                                if (stringVal == null) {
                                    stringVal = val.name;
                                } else {
                                    stringVal += ', ' + val.name;
                                }
                            }
                        })
                        value = stringVal;
                    }
                    if (question.answer.file_name != null && question.question_type.code == 'file_upload') {
                        if (question.answer.document_name != null && question.answer.document_name != "") {
                            value = question.answer.document_name + ": ";
                        } else if (!isUndefined(question.answer.file_name) && question.answer.file_name != null) {
                            // Do not require Document Name
                            value = question.answer.file_name + ": ";
                        }
                    }
                    if (value != null && question.question_type.code == 'yesno') {
                        value = (value == true || value.toString().toLowerCase() == 'true') ? 'Yes' : 'No';
                    }

                    var valid = true;
                    if (question.required) {
                        if (value == null || value.length == 0) {
                            valid = false;
                        }
                    }
                    if ($scope.validation) {
                        valid = valid && Validation.validateQuestion(null, question.validation, value);
                    }

                    if (question !== null && question.answer !== undefined) {
                        question.answer.invalid = !valid;
                    }

                    // Only require that there is a file uploaded.
                    if (question.question_type.code == 'file_upload' && question.required && (question.answer.document_id == null && (isUndefined(question.answer.file_content) || question.answer.file_content == null))) {
                        question.answer.invalid = true;
                    }

                    if (value != null && value !== '' && question.question_type.code == 'international_phone') {
                        value = '+' + value;
                    }

                    return value;
                }

                $scope.openDocument = function (question) {
                    if (question.answer.document_id != null) {
                        if ($rootScope.isPortal && $rootScope.isPortal == "True") {
                            $window.open($rootScope.portalURL + 'controller.cfm?method=publicPortalService.openDocument' + '&documentID=' + question.answer.document_id.toUpperCase() + '&code=' + question.answer.document_code, '_blank');
                        }
                        else {
                            $window.open($rootScope.internalURL + 'controller.cfm?method=publicPortalService.openDocument' + '&documentID=' + question.answer.document_id.toUpperCase() + '&code=' + question.answer.document_code, '_blank');
                        }
                    }
                }

                if ($rootScope.isPortal && $rootScope.isPortal == "True") {
                    if ($rootScope.enterprise && $rootScope.enterprise.website) {
                        $scope.portalURL = $rootScope.enterprise.website;
                    }
                    else {
                        $scope.portalURL = $rootScope.portalURL;
                    }
                }
                else {
                    if ($rootScope.enterprise && $rootScope.enterprise.site_location) {
                        $scope.portalURL = $rootScope.enterprise.site_location;
                    }
                    else {
                        $scope.portalURL = $rootScope.internalURL;
                    }
                }


                $scope.removeGroup = function (groups, index, group) {
                    modalInstance = $uibModal.open({
                        animation: true,
                        templateUrl: 'templates/confirm/confirm.html',
                        controller: 'ConfirmModalController',
                        resolve: {
                            message: function () {
                                var record = "group";
                                var dataset = "";
                                if (groups[index].component_data_set_code && groups[index].component_data_set_code.length > 1) {
                                    if (groups[index].component_data_set_code == "criminal_history") {
                                        record = "criminal history";
                                        dataset = "";
                                    } else {
                                        record = groups[index].component_data_set_code.substring(groups[index].component_data_set_code.indexOf("_") + 1, groups[index].component_data_set_code.length - 1) + "'s affiliation";
                                        record = record.replace("policie", "policy").replace("training_location", "location");
                                        dataset = " from the " + groups[index].component_data_set_code.substring(0, groups[index].component_data_set_code.indexOf("_"));
                                    }
                                }
                                return "Are you sure you would like to remove this " + record + dataset + "?";
                            }
                        }
                    });
                    
                    modalInstance.result.then(function (result) {
                        if (result) {
                            if (index == null) {
                                updateArray(groups, group, true);
                            }
                            else {
                                groups.splice(index, 1);
                            }
                            // If we just removed the last record, we want add it back but with blank answers (effectively functioning like clearing out the answers)
                            if (groups.length == 0) {
                                $scope.addGroup($scope.component);
                            }
                            $scope.initializeAnswers();
                        }
                    });
                }

                $scope.initGroup = function (group, component, setHeaders) {
                    group.parameters = angular.copy(component.parameters);

                    var mileageUsed = false;
                    if (setHeaders) {
                        group.headers = [];
                        group.questions.forEach(function (question) {
                            if (question.show_in_grid && (typeof $scope.globalHeaders == "undefined" || typeof $scope.globalHeaders[question.id] != "undefined")) {
                                group.headers.push(question);
                            }
                            if (question.data_point_code && question.data_point_code.includes('vehicle_mileage')) {
                                mileageUsed = true;
                            }
                            question.sub_components.forEach(function (subComponent) {
                                subComponent.groups[0].questions.forEach(function (subQuestion) {
                                    if (subQuestion.show_in_grid && (typeof $scope.globalHeaders == "undefined" || typeof $scope.globalHeaders[subQuestion.id] != "undefined")) {
                                        group.headers.push(subQuestion);
                                    }
                                });
                            });
                        });
                    }

                    if (mileageUsed) {
                        var vehicleId;
                        if (vehicleId === null && $scope.datapointAnswers && $scope.datapointAnswers.service_vehicles_vehicle_id.length > 0) { vehicleId = $scope.datapointAnswers.service_vehicles_vehicle_id[0].value; }
                        if ($scope.inspectionChecklist && $scope.inspectionChecklist.vehicle_id) {
                            vehicleId = $scope.inspectionChecklist.vehicle_id;
                        } else if (group.vehicle_id) {
                            vehicleId = group.vehicle_id;
                        } else if (group.parameters && group.parameters.vehicle_id) {
                            vehicleId = group.parameters.vehicle_id;
                        } else if ($scope.datapointAnswers && $scope.datapointAnswers.service_vehicles_vehicle_id && $scope.datapointAnswers.service_vehicles_vehicle_id.length > 0) {
                            vehicleId = $scope.datapointAnswers.service_vehicles_vehicle_id[0].value;
                        }
                        Vehicles.getRecentVehicleMileageByVehicleId(vehicleId).then(function (record) {
                            group.lastVehicleMileageData = record;
                        });
                    }
                }

                $scope.initComponent = function (component) {
                    if (component.groups != null && component.groups.length == 1 && component.other_file_groups.length > 0) {
                        component.groups[0].edit = true;
                    }

                    component.headers = [];
                    $scope.globalHeaders = {};
                    component.groups[0].questions.forEach(function (question) {
                        if (question.show_in_grid) {
                            component.headers.push(question);
                            $scope.globalHeaders[question.id] = question;
                        }
                        if (question.sub_components != null) {
                            question.sub_components.forEach(function (subComponent) {
                                subComponent.groups[0].questions.forEach(function (subQuestion) {
                                    if (subQuestion.show_in_grid) {
                                        component.headers.push(subQuestion);
                                        $scope.globalHeaders[subQuestion.id] = subQuestion;
                                    }
                                });
                            });
                        }
                    });
                }

                $scope.$watch('component', function (component) {
                    $scope.initComponent(component);
                    component.groups.forEach(function (group) {
                        $scope.initGroup(group, component, true);
                    });
                });

                $scope.collapsed = function (component) {
                    return component.allow_multiple_groups && component.groups_until_list != null && component.groups != null && component.groups_until_list <= (component.groups.length + component.other_file_groups.length);
                }

                $scope.setEdit = function (group) {
                    if ($scope.groupForms[group.id] != null) {
                        group.edit = !$scope.groupForms[group.id].$valid;
                    }
                }

                $scope.closeGroup = function (group) {
                    // It's really dumb, but we can't actually submit the group's form, because in IE that submits the entire form as well
                    // But we need the form for validation, so we'll just fake it a bit
                    var form = $scope.groupForms[group.id];
                    if (form != null && form.$valid) {
                        group.edit = false;
                        group.changed = true;
                    } else {
                        $scope.$broadcast("form:submit");
                    }
                }

                $scope.removeGroupFromServiceUserChangesList = function (group, remove) {
                    updateArray($scope.component.groups, group, remove);

                    // If we just removed the last record, we want add it back but with blank answers (effectively functioning like clearing out the answers)
                    if ($scope.component.groups.length == 0) {
                        $scope.addGroup($scope.component);
                    }
                    $scope.initializeAnswers();
                }

                $scope.editPersonnel = function (component, group, parameters, datapointAnswers, fromGridEditButton) {
                    // Create a promise to ensure group initialization is complete
                    var initializeGroup = function (initGroup) {
                        return new Promise(function (resolve) {
                            if (initGroup && !initGroup.parameters) {
                                $scope.$evalAsync(function () {
                                    $scope.initGroup(initGroup, component, false);
                                    resolve(initGroup);
                                });
                            } else {
                                resolve(initGroup);
                            }
                        });
                    };

                    var groupToUse;
                    if (group != null) {
                        groupToUse = group;
                    } else if (group == null) {
                        if (component.groups.length == 1 && (component.groups[0].single_group_action == "" || component.groups[0].single_group_action === undefined)) {
                            groupToUse = component.groups[0];
                        } else {
                            $scope.addGroup($scope.component);
                            $scope.initGroup(component.groups[component.groups.length - 1], component, false);
                            groupToUse = component.groups[component.groups.length - 1];
                        }
                    }

                    // Wait for initialization before opening modal
                    initializeGroup(groupToUse).then(function (initializedGroup) {
                        // Force a digest cycle to get changes
                        if (!$scope.$$phase && !$scope.$root.$$phase) {
                            $scope.$apply();
                        }

                        modalInstance = $uibModal.open({
                            animation: true,
                            windowClass: 'service-user-changes-modal',
                            templateUrl: 'templates/form-builder-form/form-groups/form-groups-edit-personnel-modal.html',
                            controller: 'FormGroupsEditPersonnelModalController',
                            backdrop: ($scope.pdf || $scope.completed) ? true : false,
                            keyboard: ($scope.pdf || $scope.completed) ? true : false,
                            resolve: {
                                component: function () {
                                    return component;
                                },
                                group: function () {
                                    return initializedGroup;
                                },
                                initializeAnswers: function () {
                                    return $scope.initializeAnswers;
                                },
                                parameters: function () {
                                    return parameters;
                                },
                                datapointAnswers: function () {
                                    return datapointAnswers;
                                },
                                pdf: function () {
                                    return $scope.pdf;
                                },
                                completed: function () {
                                    return $scope.completed;
                                },
                                saving: function () {
                                    return $scope.saving;
                                },
                                defaultGroup: function () {
                                    return $scope.defaultGroup;
                                },
                                groupForms: function () {
                                    return $scope.groupForms;
                                },
                                fromGridEditButton: function () {
                                    return fromGridEditButton;
                                }
                            }
                        });

                        modalInstance.result.then(function (handledRes) {
                            if (handledRes !== undefined) {
                                if (handledRes.message == 'removeFromList' && (!$scope.pdf && !$scope.completed)) {
                                    // Remove From List button was clicked in modal
                                    $scope.removeGroupFromServiceUserChangesList(handledRes.group, true);
                                }
                            }
                        }, function (unhandledRes) {
                            if (unhandledRes !== undefined) {
                                if (unhandledRes.message == "pressedEsc" && unhandledRes.remove == true && (!$scope.pdf && !$scope.completed)) {
                                    //esc key was pressed, and it was not from the grid edit button
                                    $scope.removeGroupFromServiceUserChangesList(unhandledRes.group, true);
                                }
                            }
                        });
                    });
                };

                $scope.$on('$locationChangeStart', function () {
                    if (modalInstance) {
                        modalInstance.dismiss('cancel');
                    }
                });

                $scope.getQuestionByDataPointCode = function (group, dataPointCode) {
                    var question = group.questions.find(function (question) {
                        return question.data_point_code === dataPointCode;
                    });
                    return question;
                };

                $scope.getActionText = function (actionValue) {
                    switch (actionValue) {
                        case 'a':
                            return 'Added to roster';
                        case 'u':
                            return 'Updated roster';
                        case 'r':
                            return 'Removed from roster';
                        default:
                            return '';
                    }
                };
            }],
            replace: true,
            transclude: true,
            templateUrl: 'templates/form-builder-form/form-groups/form-groups.html',
            link: function (scope, elem, attrs, ctrl) {

                scope.groupForms = {};

                scope.$on('$destroy', function () {
                    if (elem) {
                        angular.element(elem).off(); // deregister all event handlers
                        angular.element(elem).remove();
                        elem = null;
                    }
                });
            }
        };
    }])
;